import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "User_Profile_Add",
	"data-name": "User, Profile, Add",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11620",
			"data-name": "Path 11620",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11621",
			"data-name": "Path 11621",
			d: "M14.817,4.167a3.984,3.984,0,1,1-5.634,0,3.984,3.984,0,0,1,5.634,0",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11622",
			"data-name": "Path 11622",
			d: "M12,14.008c4.554,0,9,1.967,9,4.992v1a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V19c0-3.026,4.446-4.992,9-4.992",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11623",
			"data-name": "Path 11623",
			d: "M0,0H24V24H0Z",
			fill: "none"
		})
	]
});
export default SvgStep2;
